import { createOptionBindings } from '@ff-os/pdp-shared-redux/slices/sceneSlice';
import { PhotoPrintsSceneOptions } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsSceneOptions';
import { PhotoPrintsPdpState } from '../store';

const optionsBindings = createOptionBindings<PhotoPrintsSceneOptions, PhotoPrintsPdpState>();
const adapterSelector = optionsBindings.createEntityOptionSelectors(s => s.papers);

export const selectAllPapers = adapterSelector.selectAll;